import { Controller } from "@hotwired/stimulus"

// Column-mapping step of the CSV import: live-highlights the columns that are
// mapped to target fields, gates submit on the required mappings (passed in via
// the required value), warns about duplicate column assignments, and reveals the
// match-key selector when "update existing" is chosen. An update-only import
// (matchColumns) also requires the columns of the chosen match key.
export default class extends Controller {
  static targets = [
    "select",
    "submit",
    "requiredHint",
    "duplicateHint",
    "headerBadge",
    "matchOptions",
    "matchKey",
  ]

  static values = {
    required: { type: Array, default: ["firstname", "lastname"] },
    matchColumns: { type: Object, default: {} },
  }

  connect() {
    this.refresh()
  }

  refresh() {
    this.paintColumns()
    this.validate()
  }

  paintColumns() {
    const mappedColumns = new Map()
    this.selectTargets.forEach((select) => {
      if (select.value !== "") mappedColumns.set(select.value, select.dataset.fieldLabel)
    })

    this.element.querySelectorAll("[data-column-index]").forEach((cell) => {
      cell.classList.toggle("bg-green-50", mappedColumns.has(cell.dataset.columnIndex))
    })

    this.headerBadgeTargets.forEach((badge) => {
      const label = mappedColumns.get(badge.dataset.columnIndex)
      badge.textContent = label || ""
      badge.classList.toggle("hidden", !label)
    })
  }

  validate() {
    const valuesByField = new Map(
      this.selectTargets.map((select) => [select.dataset.field, select.value]),
    )
    const requiredMissing = this.requiredFields.some((field) => !valuesByField.get(field))

    this.submitTarget.disabled = requiredMissing
    if (this.hasRequiredHintTarget)
      this.requiredHintTarget.classList.toggle("hidden", !requiredMissing)

    const chosen = this.selectTargets.map((select) => select.value).filter((value) => value !== "")
    const hasDuplicates = new Set(chosen).size !== chosen.length
    if (this.hasDuplicateHintTarget)
      this.duplicateHintTarget.classList.toggle("hidden", !hasDuplicates)
  }

  get requiredFields() {
    if (!this.hasMatchKeyTarget) return this.requiredValue

    return [...this.requiredValue, ...(this.matchColumnsValue[this.matchKeyTarget.value] || [])]
  }

  toggleMode(event) {
    if (!this.hasMatchOptionsTarget) return

    this.matchOptionsTarget.classList.toggle("hidden", event.target.value !== "update_existing")
  }
}
